var Backbone = require('backbone')
  , Overlay = require('ui/Overlay')
  , enableDialog = require('ui/enableDialog')

var AlertView = Backbone.View.extend({
  initialize: function(options) {
    this.content = options.content
    this.html = options.html
  }
, render: function() {
    this.$el.html(
      this.content
      ? $('<p>').text(this.content)
      : this.html
    )

    return this
  }
})

module.exports = function(options) {
  options = options || {}

  var View = enableDialog(AlertView, { title: options.title || '提示' })
    , alertView = new View(options)

  return alertView.render().open()
}
